import { render, staticRenderFns } from "./TedsLauncherWelcome.vue?vue&type=template&id=45b0db18&"
import script from "./TedsLauncherWelcome.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherWelcome.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherWelcome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports